// Reusable behavior across Dnd Item types
import shortid from "shortid";

import { Stem } from "@examspark/types";

import { DroppableType } from "../../interactions/common/image-map/ImageMap";
import { DndItem } from "../../interactions/shared/Token";

// This is a 'strategy' for handling drop behavior. It is meant to allow
// for one token per gap, and will replace and swap tokens as needed.
export const replaceTokenOnDrop = (
  gapId: string,
  item: DndItem,
  drops: Stem.Drop[],
) => {
  const gapWeAreDraggingFrom = drops.find(
    (d) => d.draggableId === item.id && d.droppableId === item.gapId,
  );
  const gapWeAreDraggingOnto = drops.find((d) => d.droppableId === gapId);

  // remove any gaps that may be modified
  const newDrops: Stem.Drop[] = drops.filter(
    (d) =>
      d.instanceId !== gapWeAreDraggingFrom?.instanceId &&
      d.instanceId !== gapWeAreDraggingOnto?.instanceId,
  );

  // if we're dragging onto a gap that already has a token, swap them
  if (gapWeAreDraggingOnto?.instanceId && gapWeAreDraggingFrom?.instanceId) {
    newDrops.push({
      ...gapWeAreDraggingOnto,
      draggableId: gapWeAreDraggingFrom.draggableId,
    });
    newDrops.push({
      ...gapWeAreDraggingFrom,
      draggableId: gapWeAreDraggingOnto.draggableId,
    });
  }
  // if we're dragging an existing tokens' gap onto an empty gap, just move it
  else if (gapWeAreDraggingFrom?.instanceId) {
    newDrops.push({
      ...gapWeAreDraggingFrom,
      droppableId: gapId,
    });
  }
  // if we're dragging a token from the bank onto an empty gap
  else {
    newDrops.push({
      draggableId: item.id,
      droppableId: gapId,
      instanceId: shortid.generate(),
    });
  }

  return newDrops;
};

// This is a 'strategy' for handling drop behavior. It allows for multiple
// tokens per gap.
export const addTokenOnDrop = (
  gapId: string,
  item: DndItem,
  drops: Stem.Drop[],
) => {
  const newDrops = [...drops].filter((d) => d.instanceId !== item.instanceId);
  newDrops.push({
    draggableId: item.id,
    droppableId: gapId,
    instanceId: shortid.generate(),
  });
  return newDrops;
};

export const hideTokenAfterUse = (
  tokens: DroppableType[],
  drops: Pick<Stem.Drop, "draggableId">[],
) => {
  return tokens.filter((opt) => {
    const maxUsage = opt.item.maxUsage;
    const count = drops.filter((d) => d.draggableId === opt.item.id).length;

    if (maxUsage && count >= maxUsage) {
      return false;
    }
    return true;
  });
};
